import React from 'react';
import { Provider } from 'react-redux';

import { ConnectedRouter } from 'connected-react-router';
import { createRoot } from 'react-dom/client';

import { handleExpiringToken } from 'resources/auth/auth.handlers';
import history from 'resources/history';
import store from 'resources/store';

import App from './App';
import AuthWrapper from './AuthWrapper';

import './index.css';

const checkPageVisibility = () => {
  if (document.visibilityState === 'visible') {
    handleExpiringToken();
  }
};

document.addEventListener('visibilitychange', checkPageVisibility);

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <AuthWrapper>
        <App />
      </AuthWrapper>
    </ConnectedRouter>
  </Provider>
);
